import app from 'flarum/app';
import Dropdown from 'flarum/components/Dropdown';
import Button from 'flarum/components/Button';
import Separator from 'flarum/components/Separator';
import Group from 'flarum/models/Group';
import Badge from 'flarum/components/Badge';
import GroupBadge from 'flarum/components/GroupBadge';

const translationPrefix = 'kilowhat-formulaire.forum.permission-controls.';

function badgeForId(id) {
    const group = app.store.getById('groups', id);

    return group ? GroupBadge.component({group, label: null}) : '';
}

export default class PermissionDropdown extends Dropdown {
    static initProps(props) {
        super.initProps(props);

        props.className = 'PermissionDropdown';
        props.buttonClassName = 'Button Button--text' + (props.disabled ? ' disabled' : '');
    }

    view() {
        this.props.children = [];

        let groupIds = this.props.groupIds;

        const inherit = groupIds === null;
        const everyone = groupIds && groupIds.indexOf(Group.GUEST_ID) !== -1;
        const members = groupIds && groupIds.indexOf(Group.MEMBER_ID) !== -1;
        const adminGroup = app.store.getById('groups', Group.ADMINISTRATOR_ID);

        if (inherit) {
            this.props.label = Badge.component({icon: 'fas fa-angle-double-down'});
        } else if (everyone) {
            this.props.label = Badge.component({icon: 'fas fa-globe'});
        } else if (members) {
            this.props.label = Badge.component({icon: 'fas fa-user'});
        } else {
            this.props.label = [
                badgeForId(Group.ADMINISTRATOR_ID),
                groupIds.map(badgeForId),
            ];
        }

        if (this.showing) {
            if (!this.props.disallowInherit) {
                this.props.children.push(
                    Button.component({
                        children: [
                            Badge.component({icon: 'fas fa-angle-double-down'}),
                            ' ',
                            app.translator.trans(translationPrefix + 'inherit'),
                        ],
                        icon: inherit ? 'fas fa-check' : true,
                        onclick: () => this.save(null),
                    })
                );
            }

            if (this.props.allowGuest) {
                this.props.children.push(
                    Button.component({
                        children: [
                            Badge.component({icon: 'fas fa-globe'}),
                            ' ',
                            app.translator.trans(translationPrefix + (this.props.guestMeansDisabled ? 'disabled_members_button' : 'everyone_button')),
                        ],
                        icon: everyone ? 'fas fa-check' : true,
                        onclick: () => this.save([Group.GUEST_ID]),
                        disabled: this.isGroupDisabled(Group.GUEST_ID),
                    })
                );
            }

            this.props.children.push(
                Button.component({
                    children: [
                        Badge.component({icon: 'fas fa-user'}),
                        ' ',
                        app.translator.trans(translationPrefix + 'members_button'),
                    ],
                    icon: members ? 'fas fa-check' : true,
                    onclick: () => this.save([Group.MEMBER_ID]),
                    disabled: this.isGroupDisabled(Group.MEMBER_ID),
                }),

                Separator.component(),

                Button.component({
                    children: [
                        badgeForId(adminGroup.id()),
                        ' ',
                        adminGroup.namePlural(),
                    ],
                    icon: !inherit && !everyone && !members ? 'fas fa-check' : true,
                    disabled: !inherit && !everyone && !members,
                    onclick: e => {
                        if (e.shiftKey) e.stopPropagation();
                        this.save([]);
                    },
                })
            );

            [].push.apply(
                this.props.children,
                app.store.all('groups')
                    .filter(group => [Group.ADMINISTRATOR_ID, Group.GUEST_ID, Group.MEMBER_ID].indexOf(group.id()) === -1)
                    .map(group => Button.component({
                        icon: groupIds && groupIds.indexOf(group.id()) !== -1 ? 'fas fa-check' : true,
                        onclick: (e) => {
                            if (e.shiftKey) e.stopPropagation();
                            this.toggle(group.id());
                        },
                        disabled: this.isGroupDisabled(group.id()) && this.isGroupDisabled(Group.MEMBER_ID) && this.isGroupDisabled(Group.GUEST_ID),
                    }, [badgeForId(group.id()), ' ', group.namePlural()]))
            );
        }

        return super.view();
    }

    save(groupIds) {
        this.props.onchange(groupIds);
    }

    toggle(groupId) {
        let groupIds = this.props.groupIds || [];

        const index = groupIds.indexOf(groupId);

        if (index !== -1) {
            groupIds.splice(index, 1);
        } else {
            groupIds.push(groupId);
            groupIds = groupIds.filter(id => [Group.GUEST_ID, Group.MEMBER_ID].indexOf(id) === -1);
        }

        this.save(groupIds);
    }

    isGroupDisabled(id) {
        // Not used for now, but let's keep it so the core stays close to core
        return false;
    }
}
